import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "error-message",
  style: {"margin-top":"10px"}
}
const _hoisted_11 = {
  key: 2,
  style: {"margin-top":"10px","text-align":"center"}
}
const _hoisted_12 = {
  key: 3,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_13 = { style: {"margin":"0 10px"} }
const _hoisted_14 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#777"}
}
const _hoisted_15 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_16 = {
  key: 1,
  class: "error-message"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { style: {"text-align":"right"} }
const _hoisted_19 = {
  key: 0,
  class: "order-details-content"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_22 = {
  key: 1,
  class: "loading-indicator"
}

import { ref, onMounted, h, computed } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  useDialog,
  NTabs,
  NTabPane,
  NFormItem,
  NDatePicker,
  NSpin,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { ChangeStatus } from "@/model/base";
import { Order } from "@/model/order";
import { Organization } from "@/model/organization";
import { QueryInfo } from "@/model/common"; // QueryInfo 임포트
import { useOrderApi } from "@/composables/useOrderForm";
import { USER_ROUTES } from "@/assets/route_constants";
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트
import { useActionDialog } from "@/composables/useDialog";
import { useDownload } from "@/composables/useDownload";
const changeOrderStatusFunc = "changeOrderStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'Order',
  setup(__props) {

const { downloadQuotationFile } = useDownload();
const { show: showActionDialog } = useActionDialog();
const { deleteOrder } = useOrderApi();

const TAB = {
  PENDING: "pending",
  APPROVED: "approved",
};
const currentTab = ref(TAB.PENDING);
const dateRangeForAccepted = ref<[number, number] | null>(null);
const showAcceptedResults = ref(false);

const { loading } = useAuth(); // 전역 로딩 상태
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const componentKey = ref(0); // To force re-render if needed
const showOrgSelectModal = ref(false);
const organizationsForSelect = ref<Organization[]>([]);
const selectedOrgForOrder = ref<string | null>(null); // 선택된 기관의 SK
const orgListLoading = ref(false);
const orgListError = ref<string | null>(null);
const showOrderDetailsModal = ref(false);
const selectedOrder = ref<Order | null>(null);
const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("name");
const isPendingOrder = ref(false);

const getOrdersCallable = getCallable("getOrgOrders");
const getOrgsCallable = getCallable("getOrgs");
const getCallApiCallable = getCallable("callApi");
const searchOptions = [
  { label: "견적명", value: "name" },
  { label: "기관명", value: "client.name" },
  { label: "담당자", value: "client.deptPersonName" },
];

const isSearchEnabled = computed(() => {
  return (
    dateRangeForAccepted.value !== null || (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "")
  );
});

const baseColumns = [
  { title: "기관명", key: "client.name", resizable: true },
  { title: "견적명", key: "name", resizable: true },
  { title: "담당부서", key: "client.dept", resizable: true },
  { title: "담당자", key: "client.deptPersonName", resizable: true },
  {
    title: "총 금액",
    key: "totalPrice",
    resizable: true,
    render: (row: Order) => {
      const priceStr = common.formatNumberWithCommas(row.totalPrice);
      return `${priceStr} 원`;
    },
  },
  { title: "상태", key: "status", resizable: true, render: (row: Order) => `${common.getStatusString(row.status)}` },
  {
    title: "생성일",
    key: "createdDate",
    resizable: true,
    render: (row: Order) => {
      const timestamp = Number(row.createdDate);
      if (!isNaN(timestamp)) {
        const date = new Date(timestamp);
        return common.getYYYYMMDD2(date);
      }
      return row.createdDate || "N/A";
    },
  },
];

const pendingColumns = [
  ...baseColumns,
  {
    title: "",
    key: "actions",
    render(row: Order) {
      const buttons: any = [];
      buttons.push(
        h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => displayOrderDetails(row, true),
          },
          { default: () => "상세" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => goToEditOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "수정" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => confirmOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "확정" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => cancelOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "취소" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            type: "error",
            onClick: () => {
              deleteOrder(row.SK, false).then((success) => {
                // `deleteOrder` composable이 성공 메시지를 처리한다고 가정
                if (success) {
                  // orders.value = orders.value.filter((order) => order.SK !== row.SK);
                  // 데이터 변경 후 목록 새로고침
                  wrappedRefreshOrders();
                }
              });
            },
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "삭제" }
        )
      );
      return buttons;
    },
  },
];

const completedColumns = [
  ...baseColumns,
  {
    title: "",
    key: "actions",
    render(row: Order) {
      const buttons: any = [];
      buttons.push(
        h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => displayOrderDetails(row, false),
          },
          { default: () => "상세" }
        )
      );
      return buttons;
    },
  },
];

const orderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
  {
    title: "비고",
    key: "notes",
    resizable: true,
    render: (row: OrderItem) => `${row.notes || ""}`,
  },
];

async function fetchAcceptedOrders() {
  if (!isSearchEnabled.value) {
    message.error("조회 조건을 하나 이상 입력해주세요.");
    return;
  }

  const searchParams: { startDate?: string; endDate?: string; searchKey?: string; searchValue?: string } = {};

  if (dateRangeForAccepted.value) {
    const [startTimestamp, endTimestamp] = dateRangeForAccepted.value;
    searchParams.startDate = startTimestamp.toString();
    searchParams.endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();
  }

  if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
    searchParams.searchKey = searchTypeForAccepted.value;
    searchParams.searchValue = searchValueForAccepted.value.trim();
  }

  showAcceptedResults.value = false;
  await refreshData(searchParams);
  showAcceptedResults.value = true;
}

const getOrders = async (params: any) => {
  const queryParams: any = { ...params };

  if (currentTab.value === TAB.PENDING) {
    queryParams.status = constant.orderStatus.PENDING;
    return getOrdersCallable(queryParams);
  } else if (currentTab.value === TAB.APPROVED) {
    queryParams.status = constant.orderStatus.APPROVED;
    const hasDateRange = params.startDate && params.endDate;
    const hasSearchValue = params.searchKey && params.searchValue;

    if (hasDateRange || hasSearchValue) {
      if (hasDateRange) {
        queryParams.startDate = params.startDate;
        queryParams.endDate = params.endDate;
      }
      if (hasSearchValue) {
        queryParams.searchKey = params.searchKey;
        queryParams.searchValue = params.searchValue;
      }
      return getOrdersCallable(queryParams);
    } else {
      return { data: { Items: [], LastEvaluatedKey: null } };
    }
  }
};

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage,
  goToPreviousPage,
  refreshData,
} = usePagination<
  Order,
  { status?: string; startDate?: string; endDate?: string; searchKey?: string; searchValue?: string }
>(
  getOrders,
  10 // 페이지 크기
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshOrders() {
  loading.value = true;
  const searchParams: { searchKey?: string; searchValue?: string } = {};

  if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
    searchParams.searchKey = searchTypeForPending.value;
    searchParams.searchValue = searchValueForPending.value.trim();
  }
  await refreshData(searchParams);
  loading.value = false;
}

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await goToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await goToPreviousPage();
  loading.value = false;
}

async function fetchOrganizationsForSelect() {
  loading.value = true;
  orgListLoading.value = true;
  orgListError.value = null;
  try {
    const result = await getOrgsCallable({});
    organizationsForSelect.value = common.getItemListFromFunctionResult(result);
  } catch (err: any) {
    console.error("기관 목록(선택용) 로딩 실패:", err);
    orgListError.value = "기관 목록을 불러오는데 실패했습니다.";
  } finally {
    orgListLoading.value = false;
    loading.value = false;
  }
}

const organizationOptions = computed(() => organizationsForSelect.value);

function openOrganizationSelectModal() {
  selectedOrgForOrder.value = null;
  showOrgSelectModal.value = true;
  if (organizationsForSelect.value.length === 0) {
    fetchOrganizationsForSelect();
  }
}

function closeOrganizationSelectModal() {
  showOrgSelectModal.value = false;
}

async function displayOrderDetails(order: Order, isPending: boolean) {
  selectedOrder.value = order;
  isPendingOrder.value = isPending;
  showOrderDetailsModal.value = true;
}

function closeOrderDetailsModal() {
  showOrderDetailsModal.value = false;
}

function onOrgSelectModalClose() {
  selectedOrgForOrder.value = null;
}
function onOrderDetailsModalClose() {
  selectedOrder.value = null; // 상세 정보 초기화
}

function goToEditOrder(orderSK: string) {
  router.push({ name: USER_ROUTES.OrgOrderEdit.Name, params: { SK: orderSK } });
}

async function changeOrderStatus(orderSK: string, status: constant.orderStatus) {
  let job: string | null = null;
  if (status == constant.orderStatus.APPROVED) {
    job = "확정";
  } else if (status == constant.orderStatus.CANCELED) {
    job = "취소";
  } else {
    return;
  }
  showActionDialog({
    title: `견적 ${job}`,
    content: `이 견적을 ${job} 하시겠습니까? ${job} 후에는 수정할 수 없습니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: `${job} 중...`,
    onConfirm: async () => {
      const data: ChangeStatus = {
        SK: orderSK,
        status: status,
      };
      const payload: {
        status: constant.orderStatus;
        type: constant.orderType;
        data: ChangeStatus;
      } = {
        status: status,
        type: constant.orderType.BODY,
        data: data,
      };
      const result = await getCallApiCallable(makeCallApiParam(changeOrderStatusFunc, payload));
      if (common.evalFunctionResult(result)) {
        message.success(`견적이 성공적으로 ${job} 되었습니다.`);
        const orderIndex = orders.value.findIndex((o) => o.SK === orderSK);
        if (orderIndex !== -1 && orders.value[orderIndex]) {
          orders.value[orderIndex].status = status;
        }
      } else {
        message.success(common.getResultError(result) || `견적 ${job} 중 오류가 발생했습니다.`);
      }
      return;
    },
  });
}

async function cancelOrder(orderSK: string) {
  changeOrderStatus(orderSK, constant.orderStatus.CANCELED);
}

async function confirmOrder(orderSK: string) {
  changeOrderStatus(orderSK, constant.orderStatus.APPROVED);
}

function confirmOrganizationSelection() {
  if (selectedOrgForOrder.value) {
    router.push({
      name: USER_ROUTES.OrgOrderRegister.Name,
      params: { SK: selectedOrgForOrder.value },
      query: { origin: USER_ROUTES.OrgOrder.Name },
    });
    closeOrganizationSelectModal();
  } else {
    message.warning("기관을 선택해주세요.");
  }
}

async function onFileDonwload(row: Order) {
  loading.value = true;
  await downloadQuotationFile(row.quotation_pdf, row.name);
  loading.value = false;
}

async function handleTabChange(tabName: string) {
  currentTab.value = tabName;
  orders.value = [];
  error.value = null;
  if (tabName === TAB.APPROVED) {
    showAcceptedResults.value = false;
    dateRangeForAccepted.value = null;
    searchValueForAccepted.value = null;
    searchTypeForAccepted.value = "name";
  } else {
    searchValueForPending.value = null;
    searchTypeForPending.value = "name";
    await wrappedRefreshOrders();
  }
}

onMounted(() => {
  if (currentTab.value === TAB.PENDING) {
    wrappedRefreshOrders(); // 초기 데이터 로드
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, _unref(loading)]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, "견적 관리", -1)
                ])),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _createElementVNode("div", null, [
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: openOrganizationSelectModal,
                  class: "action-button"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" 견적서 등록 ")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(NTabs), {
                  type: "line",
                  animated: "",
                  value: currentTab.value,
                  "onUpdate:value": [
                    _cache[5] || (_cache[5] = ($event: any) => ((currentTab).value = $event)),
                    handleTabChange
                  ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NTabPane), {
                      name: TAB.PENDING,
                      disabled: _unref(listLoading)
                    }, {
                      tab: _withCtx(() => [
                        _createVNode(_unref(NSpace), {
                          align: "center",
                          size: 8,
                          "wrap-item": false
                        }, {
                          default: _withCtx(() => [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "확정 대기 중", -1)),
                            (_unref(listLoading) && currentTab.value === TAB.PENDING)
                              ? (_openBlock(), _createBlock(_unref(NSpin), {
                                  key: 0,
                                  size: "small"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(NSpace), {
                          vertical: "",
                          style: {"margin-top":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NSpace), {
                              align: "baseline",
                              "item-style": "display: flex;"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NFormItem), {
                                  label: "검색",
                                  style: {"min-width":"350px"},
                                  "label-placement": "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NInputGroup), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NSelect), {
                                          value: searchTypeForPending.value,
                                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchTypeForPending).value = $event)),
                                          options: searchOptions,
                                          style: {"width":"120px"}
                                        }, null, 8, ["value"]),
                                        _createVNode(_unref(NInput), {
                                          value: searchValueForPending.value,
                                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValueForPending).value = $event)),
                                          placeholder: "검색어를 입력하세요",
                                          clearable: ""
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NFormItem), {
                                  style: {"min-width":"300px"},
                                  "label-placement": "left"
                                }),
                                _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NButton), {
                                      type: "primary",
                                      onClick: wrappedRefreshOrders
                                    }, {
                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                        _createTextVNode(" 조회 ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_unref(listLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "견적 목록을 불러오는 중..."))
                          : _createCommentVNode("", true),
                        (_unref(error))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                          : _createCommentVNode("", true),
                        (!_unref(listLoading) && !_unref(error))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                (_unref(orders).length > 0)
                                  ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                      key: 0,
                                      columns: pendingColumns,
                                      data: _unref(orders),
                                      pagination: false,
                                      bordered: true
                                    }, null, 8, ["data"]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 견적이 없습니다."))
                              ]),
                              (_unref(orders).length > 0 && !_unref(listLoading) && !_unref(error))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_unref(NButton), {
                                      onClick: wrappedGoToPreviousPage,
                                      disabled: _unref(currentPage) === 1,
                                      style: {"margin-right":"8px"}
                                    }, {
                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                        _createTextVNode(" 이전 페이지 ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                    _createVNode(_unref(NButton), {
                                      onClick: wrappedGoToNextPage,
                                      disabled: !_unref(hasNextPage)
                                    }, {
                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                        _createTextVNode(" 다음 페이지 ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["name", "disabled"]),
                    _createVNode(_unref(NTabPane), {
                      name: TAB.APPROVED,
                      disabled: _unref(listLoading)
                    }, {
                      tab: _withCtx(() => [
                        _createVNode(_unref(NSpace), {
                          align: "center",
                          size: 8,
                          "wrap-item": false
                        }, {
                          default: _withCtx(() => [
                            _cache[18] || (_cache[18] = _createElementVNode("span", null, "확정 완료", -1)),
                            (_unref(listLoading) && currentTab.value === TAB.APPROVED)
                              ? (_openBlock(), _createBlock(_unref(NSpin), {
                                  key: 0,
                                  size: "small"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(NSpace), {
                          vertical: "",
                          style: {"margin-top":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NSpace), {
                              align: "baseline",
                              "item-style": "display: flex;"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NFormItem), {
                                  label: "검색",
                                  style: {"min-width":"350px"},
                                  "label-placement": "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NInputGroup), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NSelect), {
                                          value: searchTypeForAccepted.value,
                                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchTypeForAccepted).value = $event)),
                                          options: searchOptions,
                                          style: {"width":"120px"}
                                        }, null, 8, ["value"]),
                                        _createVNode(_unref(NInput), {
                                          value: searchValueForAccepted.value,
                                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchValueForAccepted).value = $event)),
                                          placeholder: "검색어를 입력하세요",
                                          clearable: ""
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NFormItem), {
                                  label: "견적 등록일",
                                  style: {"min-width":"300px"},
                                  "label-placement": "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NDatePicker), {
                                      value: dateRangeForAccepted.value,
                                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dateRangeForAccepted).value = $event)),
                                      type: "daterange",
                                      clearable: ""
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NButton), {
                                      type: "primary",
                                      onClick: fetchAcceptedOrders,
                                      disabled: !isSearchEnabled.value
                                    }, {
                                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                                        _createTextVNode(" 조회 ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (showAcceptedResults.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _withDirectives(_createVNode(Loading, null, null, 512), [
                                [_vShow, _unref(listLoading) && currentTab.value === TAB.APPROVED]
                              ]),
                              (!_unref(listLoading) && _unref(error) && currentTab.value === TAB.APPROVED)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(error)), 1))
                                : _createCommentVNode("", true),
                              (!_unref(listLoading) && !_unref(error) && _unref(orders).length > 0 && currentTab.value === TAB.APPROVED)
                                ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                    key: 1,
                                    columns: completedColumns,
                                    data: _unref(orders),
                                    pagination: false,
                                    bordered: true,
                                    style: {"margin-top":"10px"}
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (!_unref(listLoading) && !_unref(error) && _unref(orders).length === 0 && currentTab.value === TAB.APPROVED)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 선택된 기간에 등록된 견적이 없습니다. "))
                                : _createCommentVNode("", true),
                              (_unref(orders).length > 0 && !_unref(listLoading) && !_unref(error))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_unref(NButton), {
                                      onClick: wrappedGoToPreviousPage,
                                      disabled: _unref(currentPage) === 1,
                                      style: {"margin-right":"8px"}
                                    }, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode(" 이전 페이지 ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                    _createVNode(_unref(NButton), {
                                      onClick: wrappedGoToNextPage,
                                      disabled: !_unref(hasNextPage)
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode(" 다음 페이지 ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, " 검색 조건을 지정한 후 조회 하세요. "))
                      ]),
                      _: 1
                    }, 8, ["name", "disabled"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showOrgSelectModal.value,
            "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((showOrgSelectModal).value = $event)),
            preset: "card",
            style: {"width":"600px"},
            title: "견적 대상 기관 선택",
            onAfterLeave: onOrgSelectModalClose
          }, {
            default: _withCtx(() => [
              (orgListLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, "기관 목록을 불러오는 중..."))
                : _createCommentVNode("", true),
              (orgListError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(orgListError.value), 1))
                : _createCommentVNode("", true),
              (!orgListLoading.value && !orgListError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_unref(NSelect), {
                      value: selectedOrgForOrder.value,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((selectedOrgForOrder).value = $event)),
                      placeholder: "기관을 선택하세요",
                      options: organizationOptions.value,
                      "label-field": "name",
                      "value-field": "SK",
                      filterable: "",
                      clearable: "",
                      style: {"margin-bottom":"20px"}
                    }, null, 8, ["value", "options"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(NButton), {
                        onClick: closeOrganizationSelectModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" 취소 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(NButton), {
                        type: "primary",
                        onClick: confirmOrganizationSelection,
                        disabled: !selectedOrgForOrder.value
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode(" 확인 ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showOrderDetailsModal.value,
            "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showOrderDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "견적 상세 정보",
            onAfterLeave: onOrderDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "견적명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.receiver_email), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당부서" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.dept || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.deptPersonName || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getStatusString(selectedOrder.value.status)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getYYYYMMDD2(new Date(Number(selectedOrder.value.createdDate)))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "총 금액",
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.formatNumberWithCommas(selectedOrder.value.totalPrice)) + "원", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "결제 방법",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.value.payment_method?.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 0,
                              label: "결제 계좌",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 1,
                              label: "입금자명",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.deposit_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 2,
                              label: "입금예정일",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_date), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "견적서",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            (selectedOrder.value.quotation_pdf)
                              ? (_openBlock(), _createBlock(_unref(NButton), {
                                  key: 0,
                                  size: "small",
                                  tertiary: "",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (onFileDonwload(selectedOrder.value!)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 다운로드 (" + _toDisplayString(selectedOrder.value.name) + ".pdf) ", 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_20, "첨부된 견적서 없음"))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _cache[28] || (_cache[28] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "견적 항목", -1)),
                    _createVNode(_unref(NDataTable), {
                      columns: orderItemColumns,
                      data: selectedOrder.value.products,
                      pagination: false,
                      bordered: true,
                      size: "small"
                    }, null, 8, ["data"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_unref(NButton), {
                        onClick: closeOrderDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode(" 닫기 ")
                        ])),
                        _: 1
                      }),
                      (isPendingOrder.value)
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 0,
                            type: "primary",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (confirmOrder(selectedOrder.value.SK))),
                            disabled: selectedOrder.value.status !== constant.orderStatus.PENDING,
                            style: {"margin-right":"10px"}
                          }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode(" 견적확정 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (isPendingOrder.value)
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 1,
                            type: "primary",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (cancelOrder(selectedOrder.value.SK))),
                            disabled: selectedOrder.value.status !== constant.orderStatus.PENDING
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode(" 견적취소 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, "상세 정보를 불러오는 중..."))
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})